module.exports = __webpack_public_path__ + "static/assets/5481d6c1a4382cd36da6c3b32de92013.png";